import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/politica-privacidade-cookies')({
  component: PrivacyCookiesPage,
});

function PrivacyCookiesPage() {
  return (
    <div
      className="min-h-[60vh] bg-[#CCD0CF] text-[#06141B]"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div className="mx-auto max-w-4xl px-6 py-12 space-y-8">
        <h1 className="text-2xl sm:text-3xl font-semibold mb-2">
          Política de Privacidade — Prometeus
        </h1>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">1) Quem somos</h2>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              O Prometeus é uma plataforma de gestão de processos e rotinas jurídicas (“Plataforma”).
            </p>
            <p>
              O “Controlador” (responsável pelas decisões sobre o tratamento) e os dados de contato oficiais (e-mail, endereço, CNPJ) devem ser informados aqui antes da publicação.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">2) A quais dados esta política se aplica</h2>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Esta Política se aplica a dados pessoais tratados quando o usuário: (i) cria conta e usa a Plataforma, (ii) contrata planos, (iii) fala com suporte, (iv) navega no site/painel.
            </p>
            <p>
              Ela também pode abranger dados de terceiros inseridos pelo usuário (ex.: clientes, partes, advogados, contatos), conforme a finalidade de gestão dos casos.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">3) Quais dados coletamos</h2>
          <p className="text-sm text-[#253745] mb-3">A Plataforma pode coletar e tratar:</p>
          <div className="space-y-3 text-sm text-[#253745] ml-4">
            <p><strong>Dados de cadastro:</strong> nome, e-mail, telefone, CPF/CNPJ (se aplicável), empresa/escritório, cargo.</p>
            <p><strong>Dados de uso:</strong> logs de acesso, IP, data/hora, eventos de navegação e ações dentro do sistema (ex.: criação/edição de itens).</p>
            <p><strong>Dados inseridos pelo usuário (“Conteúdo”):</strong> informações de processos, tarefas, tags, históricos, documentos e dados relacionados.</p>
            <p><strong>Dados de cobrança:</strong> status de pagamento e identificadores de transação (dados de cartão normalmente ficam com o provedor de pagamento, quando aplicável).</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">4) Finalidades de uso (por que tratamos dados)</h2>
          <p className="text-sm text-[#253745] mb-3">Os dados são tratados para:</p>
          <div className="space-y-2 text-sm text-[#253745] ml-4">
            <p><strong>Fornecer o serviço:</strong> autenticação, gestão de conta, funcionalidades de organização/relatórios e armazenamento do Conteúdo.</p>
            <p><strong>Suporte e relacionamento:</strong> responder solicitações, corrigir erros, comunicar alterações relevantes e avisos operacionais.</p>
            <p><strong>Segurança:</strong> prevenção a fraude, abuso, incidentes e auditoria de acesso/ações.</p>
            <p><strong>Melhoria do produto:</strong> métricas de desempenho, estabilidade e entendimento de uso para evoluir funcionalidades.</p>
            <p><strong>Cobrança e gestão financeira:</strong> processar assinaturas, conciliação e emissão de comprovantes/nota quando aplicável.</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">5) Bases legais (LGPD)</h2>
          <p className="text-sm text-[#253745] mb-3">O Prometeus pode tratar dados com base em:</p>
          <div className="space-y-2 text-sm text-[#253745] ml-4">
            <p><strong>Execução de contrato e procedimentos preliminares</strong> (para entregar a Plataforma ao usuário).</p>
            <p><strong>Legítimo interesse</strong> (ex.: segurança, prevenção a fraudes, melhoria do serviço), com avaliação e respeito aos direitos do titular.</p>
            <p><strong>Cumprimento de obrigação legal/regulatória</strong> (ex.: guarda de registros quando exigida).</p>
            <p><strong>Consentimento</strong> (quando usado, será solicitado de forma destacada e poderá ser revogado).</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Compartilhamento e operadores</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">6) Com quem compartilhamos dados</h3>
          <p className="text-sm text-[#253745] mb-3">O Prometeus pode compartilhar dados com:</p>
          <div className="space-y-2 text-sm text-[#253745] ml-4">
            <p><strong>Provedores (“operadores”) essenciais:</strong> hospedagem/infraestrutura, e-mail/transacional, analytics (se utilizado), suporte/helpdesk e ferramentas de comunicação.</p>
            <p><strong>Provedores de pagamento</strong> (se aplicável) para processar cobranças, prevenir fraudes e gerir assinaturas.</p>
            <p><strong>Autoridades públicas:</strong> mediante obrigação legal, ordem judicial ou requisição válida.</p>
          </div>
          <p className="text-sm text-[#253745] mt-3">
            Não vendemos dados pessoais; compartilhamentos ocorrem na medida necessária para operar a Plataforma.
          </p>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">7) Transferência internacional</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Se fornecedores de infraestrutura ou analytics processarem dados fora do Brasil, poderá haver transferência internacional, adotando-se mecanismos e salvaguardas adequadas.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Segurança, retenção e direitos</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">8) Segurança da informação</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              São adotadas medidas de segurança administrativas e técnicas razoáveis para proteger dados contra acesso não autorizado, perda e alteração indevida.
            </p>
            <p>
              Mesmo assim, nenhum sistema é completamente imune; em caso de incidentes relevantes, poderão ocorrer comunicações conforme a gravidade e a necessidade.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">9) Retenção e exclusão</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Os dados são mantidos pelo tempo necessário para cumprir as finalidades desta Política, obrigações legais e exercício regular de direitos.
            </p>
            <p>
              Após encerramento/cancelamento, pode existir um período de retenção para exportação e reativação, e depois exclusão ou anonimização, conforme regras do serviço.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">10) Direitos do titular</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              O titular pode solicitar: confirmação e acesso, correção, anonimização/eliminação quando cabível, portabilidade quando aplicável, informações sobre compartilhamento e revisão de decisões automatizadas (se existirem).
            </p>
            <p>
              As solicitações devem ser feitas pelo canal de privacidade/suporte indicado no final desta Política.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">11) Cookies e tecnologias semelhantes (site/painel)</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Podem ser utilizados cookies estritamente necessários (login, sessão, segurança) e, se adotados, cookies de desempenho/analytics para melhorar a experiência.
            </p>
            <p>
              Caso haja cookies não essenciais, recomenda-se banner de consentimento e página de preferências.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Disposições finais</h2>
          <h3 className="text-lg font-medium text-[#11212D] mt-4">12) Crianças e adolescentes</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              A Plataforma não é destinada a menores de 18 anos; se houver tratamento incidental, deverá ser comunicado para adequação e eventual exclusão.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">13) Alterações desta política</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Esta Política pode ser atualizada para refletir mudanças do produto ou legais, com indicação de data de vigência.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">14) Contato (privacidade)</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Inclua aqui: e-mail do encarregado (DPO, se nomeado) ou canal de privacidade, além de razão social e endereço.
            </p>
            <div className="mt-4 p-4 bg-[#9BA8AB] bg-opacity-20 rounded-lg">
              <p className="font-medium mb-2">Informações de contato:</p>
              <p className="text-sm">E-mail: contato@mourarezende.com.br</p>
              <p className="text-sm">Telefone: (91) 9 8904-5502</p>
              <p className="text-sm">Endereço: R. Petúnia, 32-138 - Jardim Industrial, Maringá - PR, 87065-300</p>
              <p className="text-sm mt-2">Empresa: Prometeus</p>
              <p className="text-sm">Responsável: Gabryel Davi de Moura Rezende</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

